import { render, staticRenderFns } from "./ProductTags.vue?vue&type=template&id=134b0a62&scoped=true&"
import script from "./ProductTags.vue?vue&type=script&lang=js&"
export * from "./ProductTags.vue?vue&type=script&lang=js&"
import style0 from "./ProductTags.vue?vue&type=style&index=0&id=134b0a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b0a62",
  null
  
)

export default component.exports